import { Button, Modal } from 'react-bootstrap'
import { X } from 'lucide-react'
import { PapeletaPdfDataProvider } from './PapeletaPdfDataProvider'

export function PapeletaViewPdfModal({ id, onClose, ...props }) {
    return (
        <Modal dialogClassName='max-w-modal w-200' {...props} centered>
            <Modal.Header className='py-2'>
                <Modal.Title>Papeleta de pago de pasajes y/o viáticos</Modal.Title>
            </Modal.Header>
            <div className='px-3 py-2'>
                <div className='min-h-48 flex flex-col'>
                    <PapeletaPdfDataProvider id={id} orientation='vertical'>
                        {(papeletaUrl) => (
                            <div style={{ height: '50vh' }}>
                                <embed
                                    src={papeletaUrl}
                                    type='application/pdf'
                                    className='size-full'
                                />
                            </div>
                        )}
                    </PapeletaPdfDataProvider>
                </div>
            </div>
            <Modal.Footer className='py-2'>
                <Button onClick={onClose}>
                    <X className='size-4' />
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
